// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"72000593","262":"dc481af8","967":"6b7e246d"}[chunkId] + ".css";
};